


import Button from "comps/Button";
import CustomTable from "comps/CustomTable";
import {   useGetSenderIds } from "hooks/useSederId";
import moment from "moment";
import React, { useState } from "react";
import CreateSenderIdModal from "./createSenderId";
import { SearchIcon } from "assets/svg-code";
 
 


const SenderId: React.FC = (props) => {
	const [openModal, setModal]  = useState({type: ""})
	const [senderId, setSenderId]  = useState({})
	const [filterBySenderId, setFilterBySenderId]   = useState("")

  const { loading, senderIds, pageInfo, setPageInfo ,  handleGetSenderIds } = useGetSenderIds(filterBySenderId)


  

	const sampleCustomers: any = {
		total: pageInfo?.total || 0,
		data:   senderIds?.map((senderId: any) => (
			{
				sn: "S/N",
				key: senderId?.id,
				date: moment(senderId?.createdAt).format("DD/MM/YYYY  h:mma"),
				senderId:  senderId?.senderId,
				status: senderId?.status,
				action: senderId
			}
		 ))
	 
	  };


	  const columns = [
		{
		  title: "S.N",
		  index: "sn",
		  dataIndex: "s/n",
		  render: (text: string, record: {}, index: number) => <div>{index + 1}</div>,
		},
		{
		  title: <div>Date</div>,
		  render: (record: any) => <div>{record?.date}</div>,
		},
		{
		  title: <div>Sender ID  </div>,
		  render: (record: any) =>  <div>{record?.senderId}</div>,
		},
		{
		  title: "Status",
		  render: (record: any) => {
			return <div >
				<span  
					className={"px-5 py-2 text-xs"}  
					style={{
						backgroundColor: record?.status?.toUpperCase() === "PENDING" ?  "#c2dbf3"  : record?.status === "DECLINED" ?  "#f2a5a5" :   record?.status?.toUpperCase() === "APPROVED" ?  "#c5f4c5" : "#ffd6d6", 
						color: record?.status === "PENDING" ?  "#0a998f" : record?.status === "APPROVED" ? "#1aa11a": record?.status === "DECLINED" ?  "#ab0909"  : "#ab0909"  
					}}
				>
					{record?.status}
				</span>
			</div>;
		  },
		},
		{
		  title: "Action",
		  render: (record: any) => {
			return <div >
				<span  className={"px-5 py-2 text-xs"}  style={{border:   "1px solid #424242", color:   "#666565", cursor: "pointer"  }}
					onClick={()=> {
						setSenderId(record?.action)
						setModal({type: "VIEW_SENDER_ID"})
					}}
				>
					View Details
				</span>
			</div>;
		  },
		},
	 
	 
	  ];
 

  return (
		<div>

			<div className="py-5 lg:gap-6 xl:gap-6 flex  grid-cols-1 flex-wrap md:grid-cols-2">
				<div  className="flex-grow-0   w-auto  grow max-w-xs flex items-center border  border-[#D5D7D8] bg-[#FEFDFD]  rounded-lg  gap-x-2 px-2">
						<SearchIcon /> 
						<input
							className="border h-12 text-sm focus:outline-none block w-full   border-transparent p-2  "
							style={{cursor: "auto"}}
							type="search"
							name="search"
							onChange={(e) => setFilterBySenderId(e.target.value)}
							placeholder={  "Search by sender ID"  }
						/>
				</div>
				
				<Button
					btnText="Create Sender ID"
					variant="primary"
					type="submit"
					className="w-40   ml-3 flex justify-center   drop-shadow-md"
					onClick={() => setModal({type: "CREATE_SENDER_ID"})}
				/>
			</div>

	 

			<div className="mt-10 w-full">
				<CustomTable
					tableName="Customers"
					dataSource={sampleCustomers.data}
					loading={loading}
					columns={columns}
					pagination={{
						pageSize: pageInfo.limit,
						total: sampleCustomers.total,
						current: pageInfo.page,
						onChange: (page: any, pageSize: any) => {
							setPageInfo({...pageInfo, page, limit: pageSize || pageInfo.limit});
						},
					}}
				/>
			</div>
			<CreateSenderIdModal openModal={openModal}  setModal={setModal} onDone={()=> handleGetSenderIds()}  {...{senderId, setSenderId}}/>
    </div>
  );
};

export default SenderId;
